import cn from 'classnames';
import Link from 'next/link';

type SectionHeroProps = {
  badge: string;
  title: string;
  description: string;
  colors?: {
    badge?: string;
    title?: string;
    text?: string;
  };
  cta: {
    href: string;
    label: string;
  };
};

export default function SectionHero({
  badge,
  title,
  description,
  cta,
  colors,
}: SectionHeroProps) {
  return (
    <>
      {badge && (
        <p
          className={cn(
            `mb-6 text-sm font-medium uppercase tracking-wide`,
            colors?.badge || `text-azure-blue`,
          )}
        >
          {badge}
        </p>
      )}

      {title && (
        <h2
          className={cn(
            `text-3xl font-bold leading-snug lg:text-5xl`,
            colors?.title || `text-zodiac`,
          )}
        >
          {title}
        </h2>
      )}

      {description && (
        <p
          className={cn(
            `mt-6 text-base md:text-lg`,
            colors?.text || `text-zodiac`,
          )}
        >
          {description}
        </p>
      )}

      {cta && (
        <div className="mt-4 inline-flex space-x-4 lg:mt-10">
          <Link href={cta.href} prefetch={false}>
            <a
              className={cn(
                `group w-5/6 text-base font-medium sm:w-full`,
                colors?.badge || `text-azure-blue`,
              )}
            >
              {cta.label}
              <span className="ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1">
                &#8594;
              </span>
            </a>
          </Link>
        </div>
      )}
    </>
  );
}
